import { render, staticRenderFns } from "./ImagePromoUpload.vue?vue&type=template&id=7ceded10&scoped=true&"
import script from "./ImagePromoUpload.vue?vue&type=script&lang=js&"
export * from "./ImagePromoUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImagePromoUpload.vue?vue&type=style&index=0&id=7ceded10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceded10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VFileInput,VIcon,VImg,VProgressCircular,VRow,VSkeletonLoader,VSubheader})
